import { render } from "./chips.vue?vue&type=template&id=138baf40&scoped=true&ts=true"
import script from "./chips.vue?vue&type=script&lang=ts"
export * from "./chips.vue?vue&type=script&lang=ts"

import "./chips.vue?vue&type=style&index=0&id=138baf40&lang=scss&scoped=true"

import exportComponent from "D:\\project\\fantan\\h5\\fantan\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-138baf40"]])

export default __exports__